import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ZipService {
  private readonly apiUrl = 'https://viacep.com.br/ws/';

  constructor(private http: HttpClient) {}

  getZipData(zipCode: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${zipCode}/json/`);
  }
}
